import React, { useState } from "react";
import { Dropdown, Table } from "react-bootstrap";
import toast from "react-hot-toast";
import { BiDotsVertical } from "react-icons/bi";
import { FaDownload, FaLink } from "react-icons/fa";
import { IoTrashBinSharp } from "react-icons/io5";
import { useNavigate } from "react-router";
import { AdminService } from "../../services/admin.service";
import CustomToggle from "../Menu/CustomMenu";
import ConfirmationModal from "../Modals/Confirmation.modal";
import { FontBold, NormalText } from "../Text/TableText.formats";
import "./table.css";
import RecreateInvoicePdfModal from "../Modals/RecreateInvoicePdf.modal";

interface IInvoices {
  tableData: any;
  handleDownload: any;
  reload: any
  type: any,
}



export default function InvoicesInternationalTable({ tableData, handleDownload, reload, type }: IInvoices) {

  const [showConfirmationModal, setShowConfirmationModal] = useState<any>(undefined);
  const [showRecreateInvoicePdf, setShowRecreateInvoicePdf] = useState<boolean>(false);
  const [selectedInvoiceNumber, setSelectedInvoiceNumber] = useState<any>('');

  const handleDeleteEnrollmentInvoice = async () => {
    await AdminService.deleteEnrollmentInvoice(showConfirmationModal).then((res) => {
      if (res.status === 200) {
        toast.success("Invoice Deleted Successfully");
        setShowConfirmationModal(undefined);
        reload();
      }
    }).catch(err => {
      toast.error("Unable to delete this Invoice")
    })
  }

  const handleDownloadInvoice = (data: any) => {
    if (!data || data.length <= 5) {
      toast.error("No invoice found to download, Recreate the invoice if needed");
      return;
    }
    // window.open(data, '_blank', 'noreferrer')
    window.location.assign(data);
  }
  const statusData = (data: any) => {
    const allStatusData = data?.enrollmentId?.payment_details?.map((paymentDetail: any) => paymentDetail.status);
    const uniqueStatus: any = Array.from(new Set(allStatusData)).join(",");
    return uniqueStatus
  }

  return (
    <>
      <Table striped borderless hover responsive size="sm">
        <thead>
          <tr className="dhun-table-header text-secondary">
            <th>#</th>
            <th>Inv. No.</th>
            <th>Description</th>
            <th>Trans. Id</th>
            <th>Student Name</th>
            <th>Country</th>
            <th>CORD</th>
            <th>Status</th>
            <th>DOP</th>
            <th>Disc.</th>
            <th>Final price</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {tableData && tableData?.length > 0
            ? tableData?.map((data: any, index: any) => {
              return (
                <tr>
                  <td>
                    <NormalText value={index + 1} />
                  </td>
                  <td>{data?.invoiceNumber}</td>
                  <td>
                    {data?.items?.map((user: any) => {
                      return user?.description;
                    })}
                  </td>
                  <td>{data.transactionId || " --- "}</td>
                  <td>{data?.userAddress?.name}</td>
                  <td>{data?.userAddress?.country || " --- "}</td>
                  <td>{data.coordinator || "---"}</td>
                  <td> {statusData(data)}</td>
                  <td>{data?.dateOfPurchase}</td>
                  <td> ₹{data?.discount?.toFixed(2) || 0}</td>
                  <td> ₹{data?.totalInvoicePrice?.toFixed(2)}</td>
                  <td>
                    <Dropdown>
                      <Dropdown.Toggle
                        as={CustomToggle}
                        id="dropdown-custom-components"
                      >
                        <BiDotsVertical className="cursor-pointer" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          onClick={() => handleDownloadInvoice(data && data.invoiceUrl)}
                        >
                          <FaLink className="text-primary" />{" "}
                          <span className="fw-bold text-primary fs-12">
                            Download
                          </span>
                          {/* </a> */}
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => { setShowRecreateInvoicePdf(true); setSelectedInvoiceNumber(data?.invoiceNumber) }}
                        >
                          <FaLink className="text-primary" />{" "}
                          <span className="fw-bold text-primary fs-12">
                            Recreate Invoice
                          </span>
                          {/* </a> */}
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            setShowConfirmationModal(data._id)
                          }}
                        >
                          <IoTrashBinSharp className="text-danger" />{" "}
                          <span className="fw-bold text-danger fs-12">
                            Cancel
                          </span>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <ConfirmationModal
                      show={showConfirmationModal ? true : false}
                      setShow={() => { setShowConfirmationModal(undefined) }}
                      handleDelete={handleDeleteEnrollmentInvoice}
                    />
                  </td>
                </tr>
              );
            })
            : "No data found"}
        </tbody>
      </Table>
      <RecreateInvoicePdfModal
              show={showRecreateInvoicePdf}
              onClose={() => { setShowRecreateInvoicePdf(false);  setSelectedInvoiceNumber('');}}
              invoice={selectedInvoiceNumber}
              invoiceType={type}
            />
    </>
  );
}
